import { Injectable } from '@angular/core';

import { Category } from 'app/question/category.model';
import { DropdownItem } from 'app/shared/dropdown-item.interface';

@Injectable()
export class DropdownItemService {
  public static categoryMapper(category: Category[]): DropdownItem[] {
   return (
      category.map(
        (categoryItem: Category) => {
          return {
            value: categoryItem,
            label: categoryItem.name
          }
        }
      )
    );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/dropdown-item.service.ts